// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateOverrideRequest
 */
export interface CreateOverrideRequest {
  /**
   * User creating the override.
   * @type {string}
   * @memberof CreateOverrideRequest
   */
  createdBy: string;
  /**
   * Comment explaining the override.
   * @type {string}
   * @memberof CreateOverrideRequest
   */
  comment: string;
  /**
   * State of the override (funded or unfunded).
   * @type {string}
   * @memberof CreateOverrideRequest
   */
  state: CreateOverrideRequestStateEnum;
}

/**
 * @export
 */
export const CreateOverrideRequestStateEnum = {
  Funded: 'funded',
  Unfunded: 'unfunded',
} as const;
export type CreateOverrideRequestStateEnum =
  (typeof CreateOverrideRequestStateEnum)[keyof typeof CreateOverrideRequestStateEnum];

/**
 * Check if a given object implements the CreateOverrideRequest interface.
 */
export function instanceOfCreateOverrideRequest(
  value: object,
): value is CreateOverrideRequest {
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('comment' in value) || value['comment'] === undefined) return false;
  if (!('state' in value) || value['state'] === undefined) return false;
  return true;
}

export function CreateOverrideRequestFromJSON(
  json: any,
): CreateOverrideRequest {
  return CreateOverrideRequestFromJSONTyped(json, false);
}

export function CreateOverrideRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateOverrideRequest {
  if (json == null) {
    return json;
  }
  return {
    createdBy: json['createdBy'],
    comment: json['comment'],
    state: json['state'],
  };
}

export function CreateOverrideRequestToJSON(json: any): CreateOverrideRequest {
  return CreateOverrideRequestToJSONTyped(json, false);
}

export function CreateOverrideRequestToJSONTyped(
  value?: CreateOverrideRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    createdBy: value['createdBy'],
    comment: value['comment'],
    state: value['state'],
  };
}
